import { PerspectiveCamera } from 'three'
import { useUnitScale } from '@/composables/useUnitScale'

// This composable now has one job: calculate the final 3D world position of an HTML element.
export function use3dPlacement() {

    const calculate3dPosition = (linkedEl: HTMLElement, camera: PerspectiveCamera) => {
      
    const { getVisibleSize } = useUnitScale(camera)
    const scrollTop = window.scrollY || 0

    // getBoundingClientRect().top gives the position relative to the viewport.
    // Adding the current scroll position gives its absolute position from the top of the document.
    
    const elementTopInPixels = linkedEl.getBoundingClientRect().top + scrollTop
    
    const { unitsPerPixelY } = getVisibleSize()
    
    // Convert the pixel position to 3D units.
    // This formula MUST be the inverse of the camera's movement formula in useScroll.ts
    const y3D = -elementTopInPixels * unitsPerPixelY    
    return y3D

  }

  return {
    calculate3dPosition,
  }
}
